import React, { useLayoutEffect, useRef, useState } from "react";
import "./Toolbar.css";

function Toolbar({ onMenu, onHelp, onSettings, onStats }) {
  const toolbarRef = useRef(null);
  const leftRef = useRef(null);
  const rightRef = useRef(null);
  const titleRef = useRef(null);
  const [titleOffset, setTitleOffset] = useState(0);

  useLayoutEffect(() => {
    const updateTitleOffset = () => {
      if (!toolbarRef.current || !leftRef.current || !rightRef.current || !titleRef.current) {
        return;
      }

      const toolbarRect = toolbarRef.current.getBoundingClientRect();
      const leftRect = leftRef.current.getBoundingClientRect();
      const rightRect = rightRef.current.getBoundingClientRect();
      const titleRect = titleRef.current.getBoundingClientRect();
      const safetyGap = 8;

      const desiredCenter = toolbarRect.width / 2;
      const titleHalfWidth = titleRect.width / 2;
      const safeLeftEdge = (leftRect.right - toolbarRect.left) + safetyGap;
      const safeRightEdge = (rightRect.left - toolbarRect.left) - safetyGap;

      const desiredLeft = desiredCenter - titleHalfWidth;
      const desiredRight = desiredCenter + titleHalfWidth;

      let offset = 0;
      if (desiredLeft < safeLeftEdge) {
        offset += safeLeftEdge - desiredLeft;
      }
      if (desiredRight + offset > safeRightEdge) {
        offset += safeRightEdge - (desiredRight + offset);
      }

      setTitleOffset(offset);
    };

    updateTitleOffset();
    window.addEventListener("resize", updateTitleOffset);

    const observer = new ResizeObserver(updateTitleOffset);
    observer.observe(toolbarRef.current);
    observer.observe(leftRef.current);
    observer.observe(rightRef.current);
    observer.observe(titleRef.current);

    return () => {
      window.removeEventListener("resize", updateTitleOffset);
      observer.disconnect();
    };
  }, []);

  return (
    <div className="toolbar" ref={toolbarRef} style={{ "--title-offset": `${titleOffset}px` }}>
      <div className="toolbar-left" ref={leftRef}>
        <button className="icon-button" aria-label="Menu" onClick={(e) => onMenu(e)}>☰</button>
      </div>

      <div className="toolbar-center" ref={titleRef}>
        <span className="toolbar-title">Crackle</span>
      </div>

      <div className="toolbar-right" ref={rightRef}>
        <button className="icon-button" aria-label="Stats" onClick={onStats}>📊</button>
        <button className="icon-button" aria-label="Help" onClick={onHelp}>❓</button>
        <button className="icon-button" aria-label="Settings" onClick={onSettings}>⚙️</button>
      </div>
    </div>
  );
}

export default Toolbar;
